import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TextService } from './core/services/text.service';
import { environment } from '@env/environment';
import { slideInAnimation } from './shared/animations/route-animations';
import { IndexedDBService } from './core/services/indexed-db.service';
import { AuthService } from './core/services/auth.service';
import { NotificationModalComponent } from './shared/components/notification-modal/notification-modal.component';
import { AuthHeaderComponent } from './components/auth-header/auth-header.component';
import { NotificationModalService } from './core/services/NotificationModal.service';
import { ChangePasswordModalService } from './components/change-password-modal/change-password-modal.service';
import { Location } from '@angular/common';
import { QueryParamHandlerService } from './core/services/query-param-handler.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { isReturningFromFederatedRedirect } from './core/utils/federated-redirect.util';
import { FederatedRedirectOverlayComponent } from './shared/components/federated-redirect-overlay/federated-redirect-overlay.component';


@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, NotificationModalComponent, TranslateModule, AuthHeaderComponent, FederatedRedirectOverlayComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [slideInAnimation] // Agregar la animación aquí
})
export class AppComponent {

  isAnimating = false;
  public authService = inject(AuthService);
  private changePasswordService = inject(ChangePasswordModalService);
  public indexedDBService = inject(IndexedDBService);
  private modalService = inject(NotificationModalService);
  private translate = inject(TranslateService);
  private location = inject(Location);
  public router = inject(Router);
  public textService = inject(TextService);
  private queryParamHandler = inject(QueryParamHandlerService);

  public isLoadingAFederated = (computed(() => this.authService.isLoadingAFederated()));

  environment = environment;
  title = 'authEdutin';
  text$;

  constructor() {
    if (isReturningFromFederatedRedirect()) {
      this.authService.isReturningFromRedirect.set(true);
      this.authService.isLoadingAFederated.set(true);
    }

    this.text$ = this.textService.text$;

  }

  async ngOnInit() {
    try {
      await this.indexedDBService.openIndexedDB();
      this.fetchUsers();
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  }


  async fetchUsers() {
    //obtener el listado de usuarios almacenados, en caso que haya
    try {
      await this.indexedDBService.migrateUsers();
      const users = await this.indexedDBService.getAllUsers();

      this.authService.accounts.set(users);

      if (users?.length > 1) {
        this.authService.toggleContinueAsAccounts('accounts_list');
      }
      if (users?.length == 1) {
        this.authService.continue_as_account = users[0];
        this.authService.toggleContinueAsAccounts('continue_as');
      }

      const fullPath = this.location.path();
      const cleanPath = fullPath.split('?')[0].split('#')[0];

      // if (users?.length == 0 && cleanPath.includes('accounts')) {
      // this.router.navigate(['/login']);
      // }

      if (this.authService.originDomainData?.source === "business" && users?.length >= 1 && cleanPath.includes('signup')) {
        // Si el origen es business, y tiene almenos una cuenta almacenada, en vez de crear cuenta, muestra listado de cuentas
        this.router.navigate(['/account']);
      }

    } catch (error) {
      console.error('Error al obtener usuarios:', error);
    }

  }





  get isNotLogoutRoute() {
    return !this.router.url.includes('logout');
  }

  get isBusinessSignup(): boolean {
    return this.router.url.startsWith('/signup') &&
      this.authService.originDomainData?.source === 'business';
  }



  private animationTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private currentAnimationState: string | null = null; // 🔸 Guardamos el estado actual

  prepareRoute(outlet: RouterOutlet) {
    const state = outlet?.activatedRouteData?.['animationState'];
    this.currentAnimationState = state;
    // Si es null o undefined, se evita la animación.
    return state ?? null;
  }

  onAnimationStart() {
    // Solo activar si hay animación real
    if (!this.currentAnimationState) return;
    this.isAnimating = true;
    // Si había un timeout anterior, lo limpiamos
    if (this.animationTimeoutId) {
      clearTimeout(this.animationTimeoutId);
      this.animationTimeoutId = null;
    }
  }


  onAnimationDone() {
    // Solo ejecutar si hay animación real
    if (!this.currentAnimationState) return;
    // Inicia nuevo timeout solo cuando termina la animación
    this.animationTimeoutId = setTimeout(() => {
      this.isAnimating = false;
      this.animationTimeoutId = null;
    }, 3000); // o 300ms si quieres que desaparezca justo al terminar
  }


  async showModal() {
    const result = await this.modalService.open(
      this.translate.instant('auth.app.modal.confirmationTitle'),
      this.translate.instant('auth.app.modal.areYouSureContinue')
    );
    if (result) {
      // Aquí puedes ejecutar la acción cuando el usuario acepta
    } else {
      // Aquí puedes manejar el caso de cancelación
    }
  }




  async openChangePasswordModal() {
    const result = await this.changePasswordService.open();

    if (result) {
      //'Contraseña cambiada con éxito ✅');
    } else {
      //'Cambio de contraseña cancelado ❌');
    }
  }

}
